import { compose } from 'ramda';
// Used as a constant to determine the type of error
import { POST_COMMENT_FAILURE } from '../../actions/comments/commentsActions';

const getChildren = (x) => x.children;
const getName = (x) => x.user && x.user.name;
const matchById = (id) => (item) => item.id === id;

export const getComment = (state, id) => {
  const matchCommentById = matchById(id);
  const { commenting: { comments = [] } = {} } = state;
  return comments.find(matchCommentById) || {};
};

export const getCommentChildren = (state, id) =>
  compose(getChildren, getComment)(state, id);

export const getCommentChild = (state, parentId, childId) => {
  const matchCommentById = matchById(childId);
  return getCommentChildren(state, parentId).find(matchCommentById);
};

export const getChildAuthor = (state, parentId, replyParentId) =>
  compose(getName, getCommentChild)(state, parentId, replyParentId);

export const getParentAuthor = (state, parentId) =>
  compose(getName, getComment)(state, parentId);

export const hasPostingError = (state) => {
  const { commenting } = state;
  return commenting.error && commenting.errorType === POST_COMMENT_FAILURE;
};

export const hasReplyPostingError = (state, rootId) => {
  const { commenting } = state;

  return commenting.comments.some(
    (comment) => comment.id === rootId && comment.replyError
  );
};

export const getEditingNode = (comment) => comment.editing || {};

export const getEditingStatusProps = (state, commentId, parentId = null) => {
  return parentId
    ? compose(getEditingNode, getCommentChild)(state, parentId, commentId)
    : compose(getEditingNode, getComment)(state, commentId);
};

export const getIsLastPage = (state) => {
  const { commenting: { isLastPage = true } = {} } = state;
  return isLastPage;
};

export const getIsLoadingMore = (state) => {
  const { commenting: { isLoadingMore = false } = {} } = state;
  return isLoadingMore;
};

export const getHasLoadMoreError = (state) => {
  const { commenting: { loadMoreError = false } = {} } = state;
  return loadMoreError;
};

export const getTranslationNode = (comment) => comment.translation || {};

export const getTranslationStatusProps = (state, commentId, parentId) => {
  return parentId
    ? compose(getTranslationNode, getCommentChild)(state, parentId, commentId)
    : compose(getTranslationNode, getComment)(state, commentId);
};
